// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/company_info_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CompanyInfo } from "./company_info_model_pb";
import { file_bffuser_v1_company_info_model } from "./company_info_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/company_info_service.proto.
 */
export const file_bffuser_v1_company_info_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL2NvbXBhbnlfaW5mb19zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIhcKFUdldENvbXBhbnlJbmZvUmVxdWVzdCJHChZHZXRDb21wYW55SW5mb1Jlc3BvbnNlEi0KDGNvbXBhbnlfaW5mbxgBIAEoCzIXLmJmZnVzZXIudjEuQ29tcGFueUluZm8ybQoSQ29tcGFueUluZm9TZXJ2aWNlElcKDkdldENvbXBhbnlJbmZvEiEuYmZmdXNlci52MS5HZXRDb21wYW55SW5mb1JlcXVlc3QaIi5iZmZ1c2VyLnYxLkdldENvbXBhbnlJbmZvUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_company_info_model]);

/**
 * @generated from message bffuser.v1.GetCompanyInfoRequest
 */
export type GetCompanyInfoRequest = Message<"bffuser.v1.GetCompanyInfoRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetCompanyInfoRequest.
 * Use `create(GetCompanyInfoRequestSchema)` to create a new message.
 */
export const GetCompanyInfoRequestSchema: GenMessage<GetCompanyInfoRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_company_info_service, 0);

/**
 * @generated from message bffuser.v1.GetCompanyInfoResponse
 */
export type GetCompanyInfoResponse = Message<"bffuser.v1.GetCompanyInfoResponse"> & {
  /**
   * Unset when the organization has no registered company info (= 未登録).
   *
   * @generated from field: bffuser.v1.CompanyInfo company_info = 1;
   */
  companyInfo?: CompanyInfo;
};

/**
 * Describes the message bffuser.v1.GetCompanyInfoResponse.
 * Use `create(GetCompanyInfoResponseSchema)` to create a new message.
 */
export const GetCompanyInfoResponseSchema: GenMessage<GetCompanyInfoResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_company_info_service, 1);

/**
 * CompanyInfoService exposes the organization's own company info to the
 * frontend. Thin pass-through over internalapi.v1.CompanyInfoService.
 *
 * @generated from service bffuser.v1.CompanyInfoService
 */
export const CompanyInfoService: GenService<{
  /**
   * GetCompanyInfo returns the organization's company info. company_info is
   * unset when not registered (= 未登録; the frontend disables the emission
   * factor linking UI and shows the unregistered hint per AC-BSP-087).
   *
   * @generated from rpc bffuser.v1.CompanyInfoService.GetCompanyInfo
   */
  getCompanyInfo: {
    methodKind: "unary";
    input: typeof GetCompanyInfoRequestSchema;
    output: typeof GetCompanyInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_company_info_service, 0);

